import { render } from "./save-modal.vue?vue&type=template&id=d67bea3c&scoped=true"
import script from "./save-modal.vue?vue&type=script&lang=js"
export * from "./save-modal.vue?vue&type=script&lang=js"

import "./save-modal.vue?vue&type=style&index=0&id=d67bea3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67bea3c"]])

export default __exports__